module.exports = __webpack_public_path__ + "static/media/CTLI_7-391w.2fed273b.webp";